
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useGraphEvent.zh.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-xflow-hooks-use-graph-event-demo-xflow-hooks-use-graph-event"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useGraphEvent.zh.md?type=demo')
};